var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressBarStep4Horizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 336.73 39.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;}.cls-1{stroke-width:5.68px;}.cls-2{stroke-width:3.25px;}.cls-3{fill:#fff;}.cls-2.activeStroke{stroke: #e1cd00}.cls-3.activeFill{fill: #e1cd00}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "advancement 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 236.12,
    y1: 19.76,
    x2: 286.6,
    y2: 19.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 137.13,
    y1: 19.8,
    x2: 199.61,
    y2: 19.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.14,
    y1: 19.8,
    x2: 100.62,
    y2: 19.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 19.88,
    cy: 19.88,
    r: 18.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 118.87,
    cy: 19.88,
    r: 18.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.61,19.88a18.26,18.26,0,1,1,18.25,18.26,18.26,18.26,0,0,1-18.25-18.26"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2 activeStroke",
    cx: 310.86,
    cy: 19.88,
    r: 24.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 19.88,
    cy: 19.88,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 118.87,
    cy: 19.88,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 217.86,
    cy: 19.88,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3 activeFill",
    cx: 310.86,
    cy: 20.38,
    r: 15
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressBarStep4Horizontal);
export default __webpack_public_path__ + "static/media/progressBarStep4_horizontal.91f3a6fbaaa3bef4913f2f204d3d9ada.svg";
export { ForwardRef as ReactComponent };